import type { IModule, ModuleContext } from '@punica/editor';
import { ModuleLifecycleState } from '@punica/editor';
import { MODULE_NAMES } from '@punica/editor';
import { registerDefaultKeymap } from '../keyboardShortcuts/defaultKeymap.js';

/**
 * Shell KeyboardShortcuts module.
 * Depends on: kernel.commands
 */
export class KeyboardShortcutsModule implements IModule {
  readonly name = MODULE_NAMES.SHELL.KEYBOARD_SHORTCUTS;
  readonly version = '1.0.0';
  readonly dependencies: readonly string[] = [MODULE_NAMES.KERNEL.COMMANDS];

  #state: ModuleLifecycleState = ModuleLifecycleState.CREATED;

  get state(): ModuleLifecycleState {
    return this.#state;
  }

  async bootstrap(context: ModuleContext): Promise<void> {
    const { punica, registry } = context;

    const commandsState = registry.getState(MODULE_NAMES.KERNEL.COMMANDS);
    if (commandsState !== ModuleLifecycleState.BOOTSTRAPPED) {
      throw new Error(
        'kernel.commands must be bootstrapped before shell.keyboardShortcuts'
      );
    }

    if (!punica.shell?.KeyboardShortcuts?.manager) {
      throw new Error('KeyboardShortcuts manager not available');
    }
  }

  async start(_context: ModuleContext): Promise<void> {
    // Register the substrate default keymap (Cmd+J panel, Cmd+B sidebar).
    // Core commands are registered during initialize(), so binding here is
    // safe; command resolution happens at key-press time regardless.
    registerDefaultKeymap();
  }
}
